/**
 * Automatic event attachment experiment
 * Use data-events="onClick: component.method" to test
 * Method with the given name must be annotated with Armature.AutoEvents.Event
 */
"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Armature = require("../Component");
var Event = function (target, key) {
    target[key].toString = function () { return key; };
};
exports.Event = Event;
function wireEvents(eventMap, component) {
    var container = component.element;
    var els = Array.from(component.element.querySelectorAll("[data-events]"));
    if (component.element.getAttribute("data-events")) {
        els.push(component.element);
    }
    els.forEach(function (el) {
        var eventString = el.getAttribute("data-events");
        var events = eventString.split(",").map(function (v) { return v.trim(); });
        events.forEach(function (event) {
            var _a = event.split(":").map(function (v) { return v.trim(); }), eventName = _a[0], methodName = _a[1];
            var method = component[methodName];
            var domEventName = eventMap.get(eventName);
            if (!domEventName || !method) {
                return;
            }
            el.addEventListener(domEventName, function (e) { return method.call(component, e); });
        });
    });
}
var eventMap = new Map();
eventMap.set("onClick", "click");
eventMap.set("onChange", "change");
eventMap.set("onSubmit", "submit");
var Component = (function (_super) {
    __extends(Component, _super);
    function Component() {
        _super.apply(this, arguments);
    }
    Component.prototype.installed = function () {
        _super.prototype.installed.call(this);
        wireEvents(eventMap, this);
    };
    return Component;
}(Armature.Component));
exports.Component = Component;

//# sourceMappingURL=AutoEvents.js.map
